import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useWindowWidth } from '@react-hook/window-size';
import { formatBrandsBasedOnCategories } from 'components/Elements/BrandsLinks/BrandsLinks.helpers';
import LetterPicker, {
  SortingLetters,
} from 'components/Elements/LetterPicker/LetterPicker';
import Sticky from 'react-stickynode';
import pxToEm from 'theme/pxToEm';
import * as Styled from './LetterPickerContainer.styles';

import useBrands from '../../hooks/useBrands';

const LetterPickerContainer: React.FC = () => {
  const [stickyTop, setStickyTop] = useState(0);
  const [isLetterClicked, setIsLetterClicked] = useState(false);
  const [letterSelected, setLetterSelected] = useState<string>('');
  const stickyRef = useRef<HTMLDivElement>(null);
  const { filteredBrands } = useBrands();
  const windowWidth = useWindowWidth();
  const availableLetters = useMemo(() => {
    // @ts-expect-error // TODO: fix types
    const formatedBrands = formatBrandsBasedOnCategories(filteredBrands);
    return formatedBrands.map((brand: any) => brand[0]);
  }, [filteredBrands]);

  useEffect(() => {
    // After clicking letter - after 1 sec - enable back logic for sync scroll
    if (isLetterClicked) {
      setTimeout(() => setIsLetterClicked(false), 1000);
    }
  }, [isLetterClicked]);

  useEffect(() => {
    window.addEventListener('scroll', handleWindowScroll);
    return () => window.removeEventListener('scroll', handleWindowScroll);
  }, [stickyTop, isLetterClicked]);

  useEffect(() => {
    setStickyTopPotion();
  }, []);

  const setStickyTopPotion = () => {
    const announcement = document.getElementById('announcement');
    const header = document.getElementById('header');
    if (header != null) {
      const headerHeight = header?.offsetHeight;
      const additionalheight =
        announcement != null ? announcement?.offsetHeight : 0;
      const newPosition = headerHeight + additionalheight;
      if (stickyTop !== newPosition) {
        setStickyTop(headerHeight + additionalheight);
      }
    }
  };

  // @ts-expect-error // TODO: fix types
  const handleWindowScroll = () => {
    setStickyTopPotion();
    if (isLetterClicked || windowWidth >= 768) {
      return false;
    }
    const activeLetters = SortingLetters?.map((letter) => {
      const letterBox = document.getElementById(letter);
      if (letterBox != null) {
        return {
          letter,
          top: letterBox.getBoundingClientRect().top,
        };
      }
      return null;
    })?.filter((item) => {
      if (item == null) return false;
      return item.top < 300 && item.top > 0;
    });
    const activeLetter = activeLetters.pop();
    if (activeLetter != null && letterSelected !== activeLetter.letter) {
      setLetterSelected(activeLetter.letter);
    }
  };

  const handleClick = (value: string) => {
    // Hack to prevent onWindowScroll calcs, if letter was clicked
    setIsLetterClicked(true);
    setLetterSelected(value);
    const element = document.getElementById(value);
    const stickyElement = stickyRef.current;
    if (!stickyElement || !element) return;

    const stickyElementHeight = stickyElement.getBoundingClientRect().height;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + window.pageYOffset - stickyElementHeight - stickyTop;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  const pickerActiveLetter = windowWidth < 768 ? letterSelected : null;

  return (
    <Sticky top={stickyTop} bottomBoundary="#bottomLine" innerZ={3}>
      <Styled.Wrapper
        paddingBottom={pxToEm(24)}
        paddingTop={pxToEm(24)}
        ref={stickyRef}
      >
        <LetterPicker
          // @ts-expect-error // TODO: fix types
          activeLetter={pickerActiveLetter}
          onLetterPressed={handleClick}
          letterSelected={letterSelected}
          availableLetters={availableLetters ?? []}
        />
      </Styled.Wrapper>
    </Sticky>
  );
};

export default LetterPickerContainer;
